module.exports = __webpack_public_path__ + "img/text2.a5468443.png";